module.exports = __webpack_public_path__ + "static/media/footerpreview.f9499d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footerpreview.png
// module id = 137
// module chunks = 0